<template>
	<a-config-provider :locale="zhCN" :auto-insert-space-in-button="false">
		<routerView />
	</a-config-provider>
</template>

<script setup lang="ts">
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import { appStore } from '@/global-store/index';
import { useSysStore } from '@/global-store/sys.store';
import { packageApi } from './view-modules/config-manage/api';
import { message } from 'ant-design-vue';

const sysStore = useSysStore();

const { LayoutStore, WebSocketStore } = appStore;
const { TRIGGER_FULL_SCREEN } = LayoutStore;
const { F_ConnectSocket } = WebSocketStore;

F_ConnectSocket();

// let router = useRouter();
// 监听全屏状态
document.addEventListener('fullscreenchange', function () {
	const isFullscreen = document.fullscreenElement !== null;
	TRIGGER_FULL_SCREEN(isFullscreen);
});

onMounted(() => {
    // sysStore.getSysInfo();
	
});

</script>

<style lang="less">
#app {
	overflow-y: hidden;
	height: 100%;
}
</style>
